"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67],{

/***/ 35049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Pk": function() { return /* binding */ requireEmail; },
/* harmony export */   "Y0": function() { return /* binding */ validatePhoneNumber; },
/* harmony export */   "qS": function() { return /* binding */ validateDate; }
/* harmony export */ });
/* harmony import */ var awesome_phonenumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63743);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75314);
/* harmony import */ var validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Validator which requires a non-empty input.
 */ const required = (msg)=>(input)=>{
        if (!input) {
            if (msg) {
                return msg;
            }
            return "";
        }
        return undefined;
    };
const requireEmail = (msg)=>(input)=>{
        if (!validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default()(input)) {
            return msg;
        }
        return undefined;
    };
const validateDate = (msgs)=>(input)=>{
        if (!input) {
            if (!msgs) return "";
            return msgs[0];
        }
        const date = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(input, "MM/DD/YYYY", true);
        const dateNow = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(new Date());
        if (!date.isValid()) {
            if (!msgs) return "";
            return msgs[1];
        }
        if (date.isAfter(dateNow)) {
            if (!msgs) return "";
            return msgs[2];
        }
        return undefined;
    };
const validatePhoneNumber = (msg)=>(num, regionSlug)=>{
        if (num && typeof num === "string") {
            const phoneNum = (0,awesome_phonenumber__WEBPACK_IMPORTED_MODULE_0__/* .parsePhoneNumber */ .SR)(num, regionSlug);
            const isValid = phoneNum.isValid();
            if (!isValid) {
                return msg;
            }
            return undefined;
        }
    };


/***/ }),

/***/ 29414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Salesforce_SalesforceForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/components/v5/Input/utils/Validators.ts
var Validators = __webpack_require__(35049);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/v5/Transitions/Fade.tsx
var Fade = __webpack_require__(64800);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Salesforce/SalesforceFormSuccess.tsx







const SalesforceFormSuccess = (param)=>{
    let { error , setSubmitStatus  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { imgExt  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const header = error ? i18n.t("Something went wrong.") : i18n.t("Thank you!");
    const text = error ? i18n.t("Thank you for your patience! Please try again.") : i18n.t("We’ll get back to you within one business day. In the meantime, explore employer resources from our Chief Medical Officer Sujal Mandavia.");
    const resetSubmitStatus = ()=>{
        setSubmitStatus("not-submitted");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pos-r oh p8 pb40 pb30-xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fade/* default */.Z, {
                in: true,
                appear: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fs28 fs32-sm font-cb mb4",
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "fs24 fs24-sm font-cm gray800 ",
                        children: text
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                        "aria-label": i18n.t("Click to go back to the submission form and try again."),
                        className: "mt8 focus-bsDarkBlue3 event-Yd9g9c mr1",
                        onClick: resetSubmitStatus,
                        children: i18n.t("Go Back")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(V5Comp/* Btn */.un, {
                        className: "focus-bsDarkBlue3 mt8",
                        href: "https://www.youtube.com/playlist?list=PLu-GZsDFusNbZFeTN8m7RNOtGu5n7Yv4g",
                        children: [
                            i18n.t("Watch the Playlist"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-arrow-45deg fs10 ml3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                src: "/illustrations/squiggly-lines-yellow-2.".concat(imgExt),
                className: "pos-a bottom0 right0"
            })
        ]
    });
};
/* harmony default export */ var Salesforce_SalesforceFormSuccess = (SalesforceFormSuccess);

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(62276);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__(75314);
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);
// EXTERNAL MODULE: ./src/components/v5/Input/TextInput.tsx
var TextInput = __webpack_require__(85208);
;// CONCATENATED MODULE: ./src/components/v5/Salesforce/SalesforceForm.tsx















const initialFormState = {
    firstName: _constants/* dev */.WI ? "carbon" : "",
    lastName: _constants/* dev */.WI ? "eng" : "",
    title: _constants/* dev */.WI ? "eng" : "",
    company: _constants/* dev */.WI ? "carbon" : "",
    email: _constants/* dev */.WI ? "eng@carbonhealth.com" : ""
};
const initialFormValidationState = {
    firstName: false,
    lastName: false,
    title: false,
    company: false,
    email: false
};
const SalesforceForm = (param)=>{
    let { trackingCategory ="" , trackingAction ="Lead Form" , companyFieldLabel , channel ="" , submitButtonLabel , emailFieldLabel , titleFieldLabel , excludedFields =[]  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [formState, setFormState] = (0,react.useState)(initialFormState);
    const [formValidationState, setFormValidationState] = (0,react.useState)(initialFormValidationState);
    const [submitStatus, setSubmitStatus] = (0,react.useState)("not-submitted");
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | (() => number)'.
    const [linkedInConversionId, setLinkedInConversionId] = (0,react.useState)(null);
    const { recaptchaClientKey , csrfToken  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const recaptchaRef = (0,react.useRef)(null);
    const updateFormState = (key)=>(val)=>{
            setFormState({
                ...formState,
                [key]: val
            });
        };
    const updateFormValidationState = (key)=>(val)=>{
            setFormValidationState({
                ...formValidationState,
                [key]: val
            });
        };
    const onError = ()=>{
        setSubmitStatus("error");
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isSubmitDisabled) {
            return;
        }
        setSubmitStatus("submitted");
        // @ts-expect-error TS2531: Object is possibly 'null'.
        const captcha = await recaptchaRef.current.executeAsync();
        (0,api/* addToSalesforce */.u)(csrfToken, {
            FirstName: formState.firstName,
            LastName: formState.lastName,
            Title: formState.title,
            Email: formState.email,
            Company: formState.company,
            LeadSource: "web",
            channel__c: channel,
            captcha
        }).then(()=>{
            (0,Carbon/* trackToPatient */.Zr)({
                ga: {
                    category: trackingCategory,
                    action: trackingAction,
                    label: formState.company
                }
            });
            setLinkedInConversionId(_constants/* c4BLinkedInConversionId */.et);
            setSubmitStatus("success");
            setTimeout(()=>{
                setSubmitStatus("not-submitted");
            }, 15000);
        }).catch(()=>{
            onError();
        });
    };
    const isFormValid = !formState.omit("title").vals().map((val)=>Boolean(val)).includes(false) && isEmail_default()(formState.email);
    const isSubmitDisabled = submitStatus === "submitted" || submitStatus === "error" || !isFormValid;
    const fields = (0,react.useMemo)(()=>{
        return [
            {
                name: "firstName",
                label: i18n.t("First Name"),
                className: "w50p-f pr2 w100p-f-sm pr0-sm",
                defaultValue: initialFormState.firstName,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.firstName) ? (0,Validators/* required */.C1)()(formState.firstName) : undefined
            },
            {
                name: "lastName",
                label: i18n.t("Last Name"),
                className: "w50p-f pl2 w100p-f-sm pl0-sm",
                defaultValue: initialFormState.lastName,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.lastName) ? (0,Validators/* required */.C1)()(formState.lastName) : undefined
            },
            {
                name: "title",
                label: titleFieldLabel || i18n.t("Your title / position"),
                defaultValue: initialFormState.title,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.title) ? (0,Validators/* required */.C1)()(formState.title) : undefined
            },
            {
                name: "company",
                label: companyFieldLabel || i18n.t("Company name"),
                defaultValue: initialFormState.company,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.company) ? (0,Validators/* required */.C1)()(formState.company) : undefined
            },
            {
                name: "email",
                label: emailFieldLabel || i18n.t("Business email address"),
                defaultValue: initialFormState.email,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.email) ? (0,Validators/* required */.C1)()(formState.email) : undefined
            }
        ];
    }, [
        formValidationState,
        formState,
        companyFieldLabel,
        emailFieldLabel,
        titleFieldLabel,
        i18n
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white br1 minw32 minw0-sm maxw32",
        children: [
            submitStatus === "success" || submitStatus === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Salesforce_SalesforceFormSuccess, {
                error: submitStatus === "error",
                setSubmitStatus: setSubmitStatus
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p8 p4-md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    id: "salesforce-form",
                    className: "df fdc",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: fields.map((param)=>{
                                let { name , label , defaultValue , className , errorMsg  } = param;
                                return !excludedFields.includes(name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fl mb4 w100p ".concat(className),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        label: "".concat(i18n.t(label), " * "),
                                        onChange: updateFormState(name),
                                        defaultValue: defaultValue,
                                        errorMsg: errorMsg,
                                        setValidation: updateFormValidationState(name)
                                    })
                                }, name);
                            })
                        }),
                        submitStatus === "submitted" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            duration: 100,
                            in: true,
                            appear: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fs20 font-cb lh17 mv3",
                                children: i18n.t("Saving your form...")
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            "aria-label": i18n.t("Click to submit the form."),
                            className: "focus-bsDarkBlue3 t-100 event-d2ybCl",
                            bg: isSubmitDisabled ? palette.gray100 : palette.darkerYellow,
                            color: isSubmitDisabled ? palette.gray400 : "#fff",
                            type: "submit",
                            disabled: isSubmitDisabled,
                            children: submitButtonLabel || i18n.t("Submit Form")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                ref: recaptchaRef,
                sitekey: recaptchaClientKey,
                size: "invisible"
            }),
            linkedInConversionId && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                height: "1",
                width: "1",
                style: {
                    display: "none"
                },
                alt: "",
                src: "https://px.ads.linkedin.com/collect/?pid=2265524&conversionId=".concat(linkedInConversionId, "&fmt=gif")
            })
        ]
    });
};
/* harmony default export */ var Salesforce_SalesforceForm = (SalesforceForm);


/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SkipSection = (param)=>{
    let { children , hrefs , style  } = param;
    const handleSpaceAndEnter = ()=>{
        for(let i = 0; i < hrefs.length; i += 1){
            const href = hrefs[i];
            const el = document.getElementById(href); // scroll to first element in hrefs found in DOM
            if (el) {
                window.location.href = "#".concat(href);
                el.focus();
                break;
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "pos-a-f bg-white gray800 ph4 pv3 br5 showOnFocus focus-bsDarkBlue3 brdn",
        style: style,
        onClick: handleSpaceAndEnter,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipSection);


/***/ }),

/***/ 97455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var _components_SkipSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84661);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96808);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33437);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57974);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29946);











const TestimonialSlider = (param)=>{
    let { defaultTestimons , defaultHead , autoRotate , firstBgColor , firstTextColor , smallFont =false , ariaLabel  } = param;
    const [k, setK] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_8__/* .useInterval */ .Yz)(()=>{
        if ((autoRotate || isMobile) && !_common_constants__WEBPACK_IMPORTED_MODULE_7__/* .isCI */ .yg) {
            setK((k + 1) % testimons.length);
        }
    }, 8000, false);
    const head = defaultHead || i18n.t("What our patients say");
    const testimons = defaultTestimons || [
        {
            body: i18n.t("I highly recommend them to anyone needing medical attention. Reservations are easy to set up via their app and recommended to avoid wait time. Yelp only allows for 5 stars. I would give them a 10."),
            who: {
                name: "Gary",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: firstBgColor || _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint,
            color: firstTextColor || "#fff"
        },
        {
            body: i18n.t("Oh my God, finally an urgent care in our neighborhood that doesn't actually feel like an urgent care!  The space is super clean, modern, open and airy. The staff was excellent and were super friendly."),
            who: {
                name: "Gina",
                who: i18n.t("Carbon Health Los Angeles Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple,
            color: "#fff"
        },
        {
            body: i18n.t("If I could give this place 10 stars, I would. I received exceptional service from the moment I walked in, to the time I left. This place has been the best urgent care location I've ever been to."),
            who: {
                name: "Steph",
                who: i18n.t("Carbon Health San Jose Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        },
        {
            body: i18n.t("Literally amazing. They have the nicest doctors and staff, and you can get an appointment so easily and so fast! "),
            who: {
                name: "Liana",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkBlue
        },
        {
            body: i18n.t("Appreciated being seen immediately, the friendly and helpful staff, and my comprehensive care including x-rays, prescriptions called into my pharmacy and scheduling a follow-up appointment."),
            who: {
                name: "Laurie",
                who: i18n.t("Carbon Health Oakland Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint
        },
        {
            body: i18n.t("What I love is through their app (make sure you download the app - worth it) they check up on you to make sure you are ok. You are able to share any new developments."),
            who: {
                name: "Joeletta",
                who: i18n.t("Carbon Health Mountain View Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple
        },
        {
            body: i18n.t("Great urgent care! Easy to make an appointment, got seen right away, the place was clean and tidy, and the staff was extremely friendly and helpful."),
            who: {
                name: "Tessa",
                who: i18n.t("Carbon Health Berkeley Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        }
    ];
    const activeItem = testimons[k];
    const swipeHandlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_10__/* .useSwipeable */ .QS)({
        onSwipedRight: ()=>isMobile && changeSlide(-1),
        onSwipedLeft: ()=>isMobile && changeSlide(1)
    });
    const changeSlide = (val)=>{
        const nextVal = k + val > testimons.length - 1 ? 0 : k + val < 0 ? testimons.length - 1 : k + val;
        setK(nextVal);
    };
    const isXs = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("xs");
    const headingId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    const carouselId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "lg:py-36 md:py-16 pt-16 pb-10 relative text-white contrast-tbt max-w-screen transition-colors duration-500",
        style: {
            backgroundColor: testimons[k].bg
        },
        "aria-labelledby": headingId,
        "aria-roledescription": "carousel",
        ...ariaLabel && {
            "aria-label": ariaLabel
        },
        ...swipeHandlers,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative m-auto px-4 md:px-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SkipSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    hrefs: [
                        "explore-locations",
                        "footer"
                    ],
                    style: {
                        left: "2rem",
                        top: "-4rem"
                    },
                    children: i18n.t("Skip Carousel")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !activeItem.hideHeadTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-ir fs13 op1 ls2 mb8 mt0 ttu",
                            id: headingId,
                            children: activeItem.head || head
                        }),
                        activeItem.headImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb8 minh20",
                            children: activeItem.headImg
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "transition-transform duration-500 grid grid-flow-col",
                                style: {
                                    gridAutoColumns: "100%",
                                    transform: "translateX(".concat(-100 * k, "%)")
                                },
                                id: carouselId,
                                "aria-live": autoRotate || isMobile ? "off" : "polite",
                                children: testimons.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        className: "t-op200 pos-r df fdc op0 brdn pl0 m0 ".concat(i === k ? "op1" : ""),
                                        role: "group",
                                        "aria-label": i18n.t(" {{number}} of {{total}}", {
                                            number: i + 1,
                                            total: testimons.length
                                        }),
                                        "aria-hidden": i !== k,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-cm mb8 ".concat(smallFont ? "fs28 fs18-md" : "fs40 fs24-md", " lh12 lh14-md maxw64 pb24 pb16-md fx"),
                                                children: t.body
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md mb2",
                                                children: t.who.name
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md lh14 maxw12-md",
                                                children: t.who.who
                                            }),
                                            t.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: t.source,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                className: "white fs14 font-ir us pos-a",
                                                style: {
                                                    bottom: 0
                                                },
                                                children: i18n.t("Source")
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                testimons.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "df aic pos-a pos-r-xs mt4-xs",
                    style: isXs ? {} : {
                        right: "2rem",
                        bottom: isMobile ? ".25rem" : "-1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-mb fs12 mr6 ttu",
                            children: i18n.t(" {{number}} of {{total}}", {
                                number: k + 1,
                                total: testimons.length
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(-1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-left mr4 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Previous")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-right2 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Next")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 22164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ partners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
;// CONCATENATED MODULE: ./src/constants/Partners.tsx





const usePartnersConstants = ()=>{
    const benefits = [
        {
            src: "/illustrations/doctor-and-patient-mask",
            header: src_i18n/* i18n.t */.ag.t("Coordinated care delivery"),
            body: src_i18n/* i18n.t */.ag.t("We partner with hospitals, specialists, and medical groups to coordinate care delivery in local markets and better serve communities."),
            backgroundColor: palette.lightGreen,
            pattern: "0",
            imgExtension: "png"
        },
        {
            src: "/illustrations/doctor-and-patient",
            header: src_i18n/* i18n.t */.ag.t("Comprehensive first-line care"),
            body: src_i18n/* i18n.t */.ag.t("Together, we increase access points for first-line care including primary care, urgent care, and/or behavioral health capacity."),
            backgroundColor: palette.lightPurple,
            pattern: "4"
        },
        {
            src: "/illustrations/happy-healthy-person-smiling",
            header: src_i18n/* i18n.t */.ag.t("Streamline access"),
            body: src_i18n/* i18n.t */.ag.t("We seamlessly coordinate care so patients and clinicians can focus on what’s truly important."),
            backgroundColor: palette.lightBlue,
            pattern: "2"
        }
    ];
    const ctaProps = {
        "aria-label": src_i18n/* i18n.t */.ag.t("Click to scroll to the contact form."),
        href: "#get-started",
        children: src_i18n/* i18n.t */.ag.t("Talk to Our Team"),
        fontSize: 1.25,
        className: "focus-bsDarkBlue3 bold"
    };
    const testimonials = [
        {
            body: src_i18n/* i18n.t */.ag.t("Carbon Health’s fresh approach to healthcare has further established our reach and visibility as a leading provider in our region. Since our partnership, we expanded market reach and converted over 10% of new patients to our medical group."),
            bg: palette.darkerMint,
            color: "#fff",
            who: {
                name: "Aimee Brewer",
                who: src_i18n/* i18n.t */.ag.t("President, Northbay Healthcare Group")
            },
            headImg: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                src: "/partners/northbay-logo-white",
                alt: "Northbay Healthcare",
                width: 150,
                height: 38,
                extension: "svg"
            }),
            hideHeadTitle: true
        }
    ];
    return {
        benefits,
        ctaProps,
        testimonials
    };
};

;// CONCATENATED MODULE: ./src/components/v5/BenefitsColorCard.tsx



const ColorCard = (param)=>/*#__PURE__*/ {
    let { src , header , backgroundColor , list , body , pattern , className , imgExtension ="jpg"  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "pos-r ph8 pv8 pb20-xs br4 minh24rem oh maxw28 maxw20-sm ".concat(className || ""),
        style: {
            backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pos-r zIndex1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        src: src,
                        extension: imgExtension,
                        className: "mb4",
                        width: 100,
                        height: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb4 font-csb fs24 fs20-sm maxw15 lh15",
                        children: header
                    }),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: body
                    }),
                    list && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "font-ir-sm fs14-sm fs18 lh15 ml7",
                        style: {
                            listStyle: "unset"
                        },
                        children: list.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: item
                            }, item))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                src: "/paint-strokes/".concat(pattern),
                extension: "jpg",
                className: "pos-a bottom0 left0",
                layout: "fill",
                alt: ""
            })
        ]
    });
};
/* harmony default export */ var BenefitsColorCard = (ColorCard);

// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Partners/Benefits.tsx






const Benefits = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { benefits , ctaProps  } = usePartnersConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "ph8 pv30 pv10-md contrast-tbb",
        "aria-labelledby": "benefits-heading",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw70 ma",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb5 tac-md",
                    id: "benefits-heading",
                    children: i18n.t("How we work with our partners")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pv8 mb4 dg gg6 af df-sm fw jcc-md",
                    children: benefits.map((b)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsColorCard, {
                            ...b,
                            className: "mb3-sm"
                        }, b.header))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tac-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                        ...ctaProps
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Partners_Benefits = (Benefits);

;// CONCATENATED MODULE: ./src/components/v5/Partners/Outcomes.tsx






const Outcomes = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { ctaProps  } = usePartnersConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-lightMint pv24 ph4 contrast-tbb",
        "aria-labelledby": "outcomes-heading",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw70 ma df aic jcsb fdc-md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "maxw20-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        priority: true,
                        src: "/partners/nps-score",
                        extension: "png",
                        width: 838 / 2,
                        height: 1342 / 2,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "maxw36 mt8-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "fs48 lh12 fs28-md",
                            id: "outcomes-heading",
                            children: i18n.t("Example outcomes from one of our partners")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt12 lh18 mt2-md ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: [
                                    i18n.t("50% of Carbon Health primary care patients referred were new to our health system partner"),
                                    i18n.t("Patient Satisfaction (NPS) of 82"),
                                    i18n.t("Rapid pace of deployment  (700% clinic growth over 2 years)")
                                ].map((l)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "mt4 df mt6-md",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cIcon-check mt2",
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-isb ml2",
                                                children: l
                                            })
                                        ]
                                    }, l))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                ...ctaProps,
                                className: "mt12"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Partners_Outcomes = (Outcomes);

// EXTERNAL MODULE: ./src/components/v5/TestimonialSlider.tsx
var TestimonialSlider = __webpack_require__(97455);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/Salesforce/SalesforceForm.tsx + 1 modules
var SalesforceForm = __webpack_require__(29414);
;// CONCATENATED MODULE: ./src/components/v5/Partners/Contact.tsx





const Contact = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-labelledby": "contact-heading",
        className: "bg-lightYellow pv30 pt14-sm pb20-xs ph8 pos-r contrast-tbb",
        id: "get-started",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "maxw70 ma df fdc-md zIndex1 pos-r",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fx df mb10-md jcc-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "maxw26",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "fs32-xs mb5 mb2-xs maxw20",
                                    id: "contact-heading",
                                    children: i18n.t("Get in touch with our team")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fs24 fs22-sm fs16-xs font-ir-xs font-cm",
                                    children: i18n.t("We'd love to hear how Carbon Health can partner with your organization to better serve your patients and your community. We’ll respond within one business day.")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fx df jcfe jcc-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bs2 hfc bg-white maxw28-sm maxw32 w100p contrast-tb",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesforceForm/* default */.Z, {
                                submitButtonLabel: i18n.t("Contact Us"),
                                channel: "partners",
                                trackingCategory: "Carbon Partners",
                                emailFieldLabel: i18n.t("Work email address"),
                                excludedFields: [
                                    "title"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pos-a right0 bottom0 minh40-xs minw40-xs w50rem h18rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    src: "/illustrations/squiggly-lines-yellow",
                    layout: "fill",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var Partners_Contact = (Contact);

;// CONCATENATED MODULE: ./src/components/v5/Partners/Hero.tsx






const Hero = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { ctaProps  } = usePartnersConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt46 pb18 pt30-md pb4 bg-lightMint ph4 contrast-tbb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw54 ma tac",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: i18n.t("Partnering with hospitals, specialists, and medical groups to reimagine how healthcare is delivered")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                        ...ctaProps
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt30 df jcsb fw jcc-md mt10-md",
                    children: [
                        {
                            src: "jmh",
                            alt: "John Muir Health"
                        },
                        {
                            src: "northbay",
                            alt: "NorthBay Healthcare"
                        },
                        {
                            src: "prime-master",
                            alt: "Prime Healthcare"
                        }
                    ].map((param)=>/*#__PURE__*/ {
                        let { src , alt  } = param;
                        return (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                            className: "mh4 mv2-md",
                            src: "partners/".concat(src),
                            width: 220,
                            height: 50,
                            extension: "svg",
                            alt: alt
                        }, src);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Partners_Hero = (Hero);

;// CONCATENATED MODULE: ./src/pages/partners.tsx










const Partners = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { testimonials  } = usePartnersConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("How to Partner with Carbon Health"),
        pageDescription: i18n.t("Carbon Health is partnering with hospitals, specialists, and medical groups to reimagine how healthcare is delivered."),
        pageImage: "partners",
        ogAlt: i18n.t("Carbon Health is reimagining healthcare with hospitals, specialists, and medical groups."),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners_Contact, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners_Benefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners_Outcomes, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlider/* default */.Z, {
                defaultTestimons: testimonials,
                ariaLabel: i18n.t("A Testimonial from our partner")
            })
        ]
    });
};
/* harmony default export */ var partners = (Partners);


/***/ })

}]);